import axios_ from "../utils/axios";
import { usePyConfig, usePyRequest } from './usePyConfig';
export default {
  /**
   * 当前登录用户的团队列表接口
   * @returns
   */
  getUserTeamList() {
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/team/userTeamLists`).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 创建团队接口
   * @returns
   */
  createTeamHandle(data) {
    return new Promise((resolve, reject) => {
      const gpt_model_id = "dbae8562b6894872868112d5003b07ef"; // 默认 gpt-4o
      data.gpt_model_id = gpt_model_id;
      axios_("POST", `api/pandagpt/v1/team/insert`, data).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 切换团队接口
   * @returns
   */
  switchTeamHandle(data) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/team/switchTeam`, data).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 获取 成员列表
   */
  getTeamMembers(param) {
    return new Promise((resolve, reject) => {
      axios_("get", `api/pandagpt/v1/team/lists`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
  * 获取团队成员列表。
  * 使用 Python 的 team_member/lists 接口，
  */
  getTeamLists(param) {
    return new Promise((resolve, reject) => {
      usePyRequest("get", "api/pandagpt/v1/team_member/lists", param, false, false, true).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 获取当前团队客服成员；分配具体会话时可传 page_id 限定该 WABA 的可分配人员。
   * @param {{page_id?: string|number}} params
   * @returns {Promise<{code:number;data:Array<object>|null;msg:string}>}
   */
  getTeamCsUserList(params = {}) {
    return axios_("GET", "api/pandagpt/v1/teamCsConfig/get_user_cs_list", params, false, false, true);
  },
  /**
   * 获取当前团队用户可见的 WhatsApp 主页；服务端依据 token 和成员角色过滤，无需请求参数。
   * @returns {Promise<{code:number;data:Array<object>|null;msg:string}>}
   */
  getWhatsAppPageList() {
    return axios_("GET", "api/pandagpt/v1/teamCsConfig/get_whatsapp_page_list", {}, false, false, true);
  },
  /**
   * 获取当前团队 WhatsApp 会话统计；服务端依据 token 确定团队和当前客服，无需请求参数。
   * @returns {Promise<{code:number;data:{historical_count:number;assigned_to_me_count:number;pending_to_me_count:number;team_total_count:number}|null;msg:string}>}
   */
  getWhatsAppMessageCount() {
    return axios_("GET", "api/pandagpt/v1/teamCsConfig/get_message_count", {}, false, false, true);
  },
  /**
   * 更新当前团队成员的客服状态；Python 团队配置接口由请求拦截器附加 token，状态只接受在线 1 或离线 3。
   * @param {{team_id:string|number; user_id:string|number; cs_status:string|number}} param
   * @returns {Promise<DefaultResponseType>}
   */
  updateCsStatus(param = {}) {
    return axios_("POST", "api/pandagpt/v1/teamCsConfig/updateCsStatus", param, false, false, true);
  },
  /**
   * 查询 Python 团队客服分配规则；团队内所有角色可读取，超管和管理员可编辑。
   * @param {{team_id:string|number}} param
   * @returns {Promise<{code:number;data:object|null;msg:string}>}
   */
  getCsConfigDetail(param = {}) {
    return axios_("GET", "api/pandagpt/v1/teamCsConfig/detail", param, false, false, true);
  },
  /**
   * 获取按大洲分组的国家目录；服务端从 token 识别登录用户，无需请求参数。
   * @returns {Promise<{code:number;data:{data:Array<{label:string;child:Array<{code:string;country_name:string}>}>}|Array<unknown>|null;msg:string}>}
   */
  getCountriesByContinent() {
    return axios_("GET", "api/pandagpt/v1/country/getByContinent", {}, false, false, true);
  },
  /**
   * 创建或更新团队客服分配规则；Python upsert 接口允许团队超管和管理员操作。
   * @param {{team_id:string|number;direct_manual?:number;manual_strategy?:number;country_config?:Array<{user_id:string;country_list:string[]}>|null;reception_limit?:number;service_expire_time?:number;release_time?:number;history_contact_handler?:number}} param
   * @returns {Promise<{code:number;data:object|null;msg:string}>}
   */
  updateCsConfig(param = {}) {
    return axios_("POST", "api/pandagpt/v1/teamCsConfig/update", param, false, false, true);
  },
  /**
   * 获取链接邀请的链接
   * @param {*} param
   * @returns
   */
  getTeamInviteLink(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/teamInvite/linkInvite`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 创建邮件邀请
   * @param {*} param
   * @returns
   */
  createTeamInviteEmail(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/teamInvite/emailInvite`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 修改团队成员名称
   * @param {*} param
   * @returns
   */
  storeTeamMemberName(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/team/updateName`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 修改团队成员角色
   * @param {*} param
   * @returns
   */
  storeTeamMemberRole(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/team/updateRole`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 转移超级管理员
   * @param {*} param
   * @returns
   */
  handoverAdministrator(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/team/handoverAdministrator`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 撤回邀请
   * @param {*} param
   * @returns
   */
  recallInviteHandle(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/team/withdrawInvitation`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 重新邀请
   * @param {*} param
   * @returns
   */
  reDoInviteHandle(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/team/reInvite`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 获取 团队通知
   * @param {*} param
   * @returns
   */
  getTeamNotice(param) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/team/getTeamNotice`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 获取 团队详情
   * @param {*} param
   * @returns
   */
  getTeamRole(param) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/team/getTeamRole`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 移除团队
   * @param {*} param
   * @returns
   */
  removeMember(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/team/removeAdministrator`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 登录页面获取邀请信息
   * @returns
   */
  getInvitationInformation(data) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/team/invitationInformation`, data).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 登录页面获取邀请信息
   * @returns
   */
  billingRules() {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/config/billingRules`).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 修改团队名称
   * @returns
   */
  uptTeamName(data) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/team/uptTeamName`, data).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 修改团队AI模型
   * @returns
   */
  uptGptModel(data) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/team/uptGptModel`, data).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 团队消费记录，支出记录
   * @returns
   */
  costList(data) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/team/costList`, data).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 团队消费记录，支出记录
   * @returns
   */
  costDetail(data) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/team/costDetail`, data).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 获取团队可用余额
   * @returns {Promise<{code:number;msg:string;data:{balance:number}}>}
   */
  getTeamBalance() {
    return axios_("GET", "api/pandagpt/v1/team/getTeamBalance");
  },
  /**
   * 团队套餐-所有套餐
   */
  getAllPackages(param) {
    return axios_("GET", "api/pandagpt/v1/TeamPackages/orderLists", param);
  },
  /**
   * 获取已购、下月套餐设置，包括已过期套餐
   */
  getCurrentTeamPackage(param) {
    return axios_("GET", "api/pandagpt/v1/TeamPackages/purchasedPackages", param);
  },
  /**
   * 团队套餐详情
   */
  getPackageDetail(param) {
    return axios_("GET", "api/pandagpt/v1/TeamPackages/detail", param);
  },
  /**
   * 购买团队套餐，支付
   */
  PaymentRequest(type, param) {
    return axios_("POST", `api/pandagpt/v1/payment/${type}`, param);
  },
  /**
   * 获取套餐提醒
   */
  getPackageReminder() {
    return axios_("GET", `api/pandagpt/v1/team/getPackageReminder`);
  },
  /**
   * 获取团队超管手机号信息
   * @returns {Promise<{code:number;data:{mobile_number:string;mobile_prefix:string;mobile_number_key:string;};msg:string}>}
   */
  getTeamAdminMobile() {
    return axios_("GET", "api/pandagpt/v1/team/getTeamAdminMobile");
  },
  /**
   * 获取套餐 - 支付宝支付状态
   */
  getAliPayResult(param) {
    return axios_("POST", `api/pandagpt/v1/getPackagePayStatus`, param);
  },
  /**
   * 下月套餐设置接口
   */
  saveNextMonthSetting(param) {
    return axios_("POST", `api/pandagpt/v1/TeamPackages/setNextSetting`, param);
  },
  /**
   * 团队消费记录 - 新的
   */
  consumeRecords(param = {}) {
    return axios_("GET", `api/pandagpt/v1/TeamConsumeRecords/List`, param, false, false, true);
  },
  /**
   * 获取团队余额统计数据
   */
  consumptionStatistics(param) {
    return axios_("GET", `api/pandagpt/v1/TeamConsumeRecords/consumptionStatistics`, param, false, false, true);
  },
  /**
   * 设置团队套餐自动续费接口
   */
  setAutoBuyPackage(param) {
    return axios_("POST", "api/pandagpt/v1/TeamPackages/setAutoBuy", param);
  },
  /**
   * 团队充值
   */
  RechargeFetch(param, type) {
    return axios_("POST", `api/pandagpt/v1/recharge/${type}`, param);
  },
  /**
   * 团队充值记录
   */
  getRechargeLists(param) {
    const config = usePyConfig("GET", "api/pandagpt/v1/recharge/recharge_list", param);
    // return axios_("GET", `api/pandagpt/v1/team/rechargeLists`, param);
    return axios_(...Object.values(config));
  },
  /**
   * 余额充值 - 支付宝支付状态
   */
  getTeamRechargeStatus(param) {
    return axios_("POST", `api/pandagpt/v1/getTeamRechargeStatus`, param);
  },
  /**
   * 发起团队充值-空中云汇接口
   * @param {string} payment_amount 
   * @returns {Promise<DefaultResponseType<{client_secret:string; currency:string; intent_id:string;}>>}
   */
  create_payment(payment_amount) {
    const config = usePyConfig("POST", "api/pandagpt/v1/recharge/create_payment", {
      payment_amount
    });
    return axios_(...Object.values(config));
  },
  /**
   * 团队充值-状态查询
   * @param {string} intent_id 
   * @returns {Promise<DefaultResponseType<{status:number}>>}
   */
  get_payment_intent(intent_id) {
    const config = usePyConfig("GET", "api/pandagpt/v1/recharge/get_payment_intent", {
      intent_id
    });
    return axios_(...Object.values(config));
  },
  /**
   * joinmc-添加团队成员
   * @param {object} data
   */
  team_member_add_user(data) {
    return usePyRequest("post", "api/pandagpt/v1/team_member/add_user", data);
  },
  /**
   * 为团队成员关联已选主页。
   * 成员详情的社交账号弹窗确认后调用，team_id 由后端根据登录会话取得。
   * @param {{page_id_list: string[], user_id: string}} data 选中主页 ID 与目标成员 ID。
   * @returns {Promise<DefaultResponseType>} 关联结果与后端提示。
   */
  user_add_page(data) {
    return usePyRequest("post", "api/pandagpt/v1/teamCsConfig/user_add_page", data);
  },
  /**
   * joinmc-将成员移出团队
   * @param id
   * @return {Promise<DefaultResponseType>}
   */
  team_member_delete_user(id) {
    return usePyRequest("post", "api/pandagpt/v1/team_member/delete_user", {
      id
    });
  }
};